import {
  Component,
  OnInit,
  ChangeDetectionStrategy, Input, Output, EventEmitter,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ImportRequest } from '../../shared/models';
import { CustomValidators } from '../../../../shared';
import { ImportRequestStatus } from '../../shared/models';

@Component({
  selector: 'sp-admin-import-request-details',
  templateUrl: './admin-import-request-details.component.html',
  styleUrls: ['./admin-import-request-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminImportRequestDetailsComponent implements OnInit {

  @Input() importRequest: ImportRequest;
  @Output() exportDiff = new EventEmitter<void>();
  @Output() exportDiffSelectYear = new EventEmitter<void>();
  @Output() import = new EventEmitter<void>();
  @Output() submit = new EventEmitter<number>();

  feedbackMessages: any[] = [];
  formGroup: UntypedFormGroup = new UntypedFormGroup({});
  importRequestStatuses = ImportRequestStatus;

  constructor(private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.initForm();
  }

  onExportDiff() {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.importRequest && this.importRequest.fiscalYears && this.importRequest.fiscalYears.length === 1
      ? this.exportDiff.emit()
      : this.exportDiffSelectYear.emit();
  }

  onImport() {
    this.import.emit();
  }

  onSubmit() {
    this.submit.emit(this.formGroup.value.fiscalYear);
  }

  private initForm() {
    this.formGroup.addControl('fiscalYear', this.fb.control('', [Validators.required, CustomValidators.notEmptyStringValidator]));
  }
}
